import React from "react";

const ShiftWeeklyOffRules = () => {
    return <div>ShiftWeeklyOffRules</div>;
}

export default ShiftWeeklyOffRules;